import type DragViewState from "../store/schema/DragViewState";
import { mutatorAction } from "satcheljs";

// Set Drag state, should be called only from Draggable component
const setDragStateMutator: (viewState: DragViewState, isBeingDragged: boolean) => void = mutatorAction("setDragState", function (viewState: DragViewState, isBeingDragged: boolean): void {
    viewState.isBeingDragged = isBeingDragged;
});
export default setDragStateMutator;
